import Vue from 'vue';
import {NotificationLike} from '@/types/NotificationLike.type';
import {Types} from 'mongoose';
import {NotifierEvents} from '@/enums/notifier/NotifierEvents';

interface NotificationBusInterface {
    $emit(event: 'pushRtc', notification: NotificationLike): any;
    $emit(event: 'update'): any;
    /** Open the target of a notification (e.g. click on a browser notification); handled by the pop-up host */
    $emit(event: 'openNotification', notification: NotificationLike): any;
    /** Open the notification panel (e.g. "Ansehen" of a summary pop-up) */
    $emit(event: 'openPanel'): any;
    /** Open the notification settings dialog (hosted by appNotifications.vue) */
    $emit(event: 'openSettings'): any;
    $emit(event: NotifierEvents, notificationIds?: Types.ObjectId[]): any;
    $on(event: 'pushRtc', callback: (notification: NotificationLike) => void): any;
    $on(event: 'update', callback: () => void): any;
    $on(event: 'openNotification', callback: (notification: NotificationLike) => void): any;
    $on(event: 'openPanel', callback: () => void): any;
    $on(event: 'openSettings', callback: () => void): any;
    $on(event: NotifierEvents, callback: (notificationIds: Types.ObjectId[]) => void): any;
    $off(event: string, callback?: (...args: any[]) => void): any;
}

export const NotificationBus: NotificationBusInterface = new Vue();
